import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { useContextualizedFields } from '../../../hooks/useContextualizedFields.hook';

import type { ResolvableServiceUsagesContext } from '../types/context.type';

type ContextualizedFields = Readonly<
  Pick<ResolvableServiceUsagesContext, 'serviceUsages'>
>;

interface Params {
  readonly formContext?: string;
}

export const useFindResolvableServiceUsageIndexById = ({
  formContext,
}: Readonly<Params>) => {
  const fields = useContextualizedFields<ContextualizedFields>(
    {
      serviceUsages: {
        id: 'service-usages',
        name: 'serviceUsages',
      },
    },
    formContext,
  );

  const findIndexById = useCallback(
    (id: Id) =>
      fields.serviceUsages.value?.findIndex((usage) => usage._id === id) ?? -1,
    [fields.serviceUsages.value],
  );

  return findIndexById;
};
